import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import '../styles/Topbar.css';

export default function Topbar() {
  const { roles, logout } = useContext(AuthContext);

  const canSeeFacturacion = roles.includes('ADMIN') || roles.includes('DOCTOR');

  return (
    <header className="topbar">
      <nav className="topbar-left">
        <Link to="/dashboard">Inicio</Link>
        <Link to="/pacientes">Pacientes</Link>
{/*         <Link to="/calendario">Calendario</Link> */}
        {canSeeFacturacion && <Link to="/facturacion/general">Facturación</Link>}
      </nav>
      <div className="topbar-right">
        <button onClick={logout}>Cerrar sesión</button>
      </div>
    </header>
  );
}
